/**
 * product-closure-bundle.js — standalone chain product page. Adds a closure picker and a decimal
 * length input (same surcharge model as the configurator), live-updates the price, and adds the
 * chain + closure (+ a length-surcharge fee line) as ONE bundled cart line (shared _build, merged
 * by the cart-transform like a configurator piece). Data + UI: snippets/product-closure-picker.liquid.
 *
 * Self-contained: it reads the section's [data-product-variants] and [data-variant-id], hides the
 * redundant Length variant dropdown, and intercepts the product form submit.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    cents = Math.round(cents);
    function num(n, decimals, thousands, decimal) {
      decimals = decimals == null ? 2 : decimals;
      thousands = thousands || ','; decimal = decimal || '.';
      var v = (n / 100).toFixed(decimals);
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimal + parts[1] : parts[0];
    }
    if (!format) return '€' + num(cents, 2);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ');
        default: return num(cents, 2);
      }
    });
  }

  function sectionOf(el) {
    return el.closest('[id^="product-"]') || el.closest('.shopify-section') || document;
  }

  // Decode HTML entities (e.g. a "&euro;" money format) so plain-text contexts read "€".
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }

  function init(root) {
    var dataEl = root.querySelector('[data-closure-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var section = sectionOf(root);
    var form = section.querySelector('form[action*="/cart/add"]');
    var atbPrice = section.querySelector('[data-atb-price]');
    var idInput = section.querySelector('[name="id"]') || section.querySelector('[data-variant-id]');
    var variants = [];
    var vEl = section.querySelector('[data-product-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) {} }
    var money = data.moneyFormat;

    function currentVariant() {
      var id = idInput && idInput.value;
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      return v || variants[0] || null;
    }
    function chainCents() { var v = currentVariant(); return v && typeof v.price === 'number' ? v.price : 0; }
    // Money for surcharge labels: decoded (€) + trailing ",00"/".00" trimmed → "+€25".
    function moneyShort(cents) { return decode(formatMoney(cents, money)).replace(/[.,]00(?=\D*$)/, ''); }

    /* ---------------- Closure ---------------- */
    var closures = data.closures || [];
    var selected = closures.length ? closures.reduce(function (b, c) { return (b === null || c.price < b.price) ? c : b; }, null) : null;
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-closure-swatch]'));
    function markActive() {
      swatches.forEach(function (sw) {
        var on = selected && String(sw.getAttribute('data-variant-id')) === String(selected.variantId);
        sw.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function closureCents() { return selected ? selected.price : 0; }
    function closureLabel() {
      if (!selected) return '';
      return selected.title + (selected.price > 0 ? ' (+' + moneyShort(selected.price) + ')' : '');
    }

    /* ---------------- Length ---------------- */
    var lenCfg = (data.length && data.length.rules && (data.length.rules.bracelet || data.length.rules.necklace)) ? data.length : null;
    var lenInput = root.querySelector('[data-length-input]');
    var lenNote = root.querySelector('[data-length-note]');
    var lenValue = null;
    if (lenCfg && lenCfg.lengthOptionIndex >= 0) {
      var opt = section.querySelector('[data-option-index="' + lenCfg.lengthOptionIndex + '"]');
      if (opt) opt.style.display = 'none'; // length is driven by the input, not the variant dropdown
    }
    function baseKind() {
      if (!lenCfg || lenCfg.forIndex < 0) return null;
      var v = currentVariant();
      var f = v && v.options && v.options[lenCfg.forIndex];
      return f ? String(f).toLowerCase() : null;
    }
    function rule() { var b = baseKind(); return (b && lenCfg && lenCfg.rules[b]) ? lenCfg.rules[b] : null; }
    function lengthSurchargeEur() {
      var r = rule(); var b = baseKind();
      if (b !== 'necklace' || !r || r.base == null || lenValue == null) return 0;
      var over = lenValue - r.base;
      return over > 0 ? over * (lenCfg.rules.surchargePerCm || 0) : 0;
    }
    function noteText() {
      var r = rule(); if (!r) return '';
      var per = lenCfg.rules.surchargePerCm || 0;
      if (r.base == null || per <= 0) return ''; // bracelet: just a cut size
      var sx = lengthSurchargeEur();
      if (sx > 0) return window.PaoPaoLocalizeMessage("includes_surcharge", {amount:moneyShort(sx * 100),extra:lenValue-r.base,base:r.base});
      return window.PaoPaoLocalizeMessage("included_length", {base:r.base,amount:moneyShort(per * 100)});
    }
    function syncLengthForBase() {
      if (!lenCfg) return;
      var r = rule();
      if (!r) { if (lenInput) lenInput.closest('[data-length-field]') && (lenInput.closest('[data-length-field]').style.display = 'none'); lenValue = null; return; }
      var field = lenInput && lenInput.closest('[data-length-field]');
      if (field) field.style.display = '';
      var def = baseKind() === 'necklace' ? r.base : Math.min(Math.max(19, r.min), r.max);
      if (lenValue == null || lenValue < r.min || lenValue > r.max) lenValue = def;
      if (lenInput) { lenInput.min = r.min; lenInput.max = r.max; lenInput.value = String(lenValue); lenInput.placeholder = r.min + '–' + r.max; }
      if (lenNote) lenNote.innerHTML = noteText();
    }
    if (lenInput) {
      lenInput.addEventListener('input', function () {
        var r = rule(); if (!r) return;
        var raw = lenInput.value.trim();
        if (raw === '') { if (lenNote) lenNote.textContent = ''; return; }
        var v = Math.round(parseFloat(raw));
        if (!isFinite(v)) return;
        if (v < r.min) { if (lenNote) lenNote.textContent = window.PaoPaoLocalizeMessage("min_length", {length:r.min}); return; }
        if (v > r.max) { if (lenNote) lenNote.textContent = window.PaoPaoLocalizeMessage("max_length", {length:r.max}); return; }
        lenValue = v;
        if (lenNote) lenNote.innerHTML = noteText();
        applyTotal();
      });
      lenInput.addEventListener('change', function () { if (lenValue != null) lenInput.value = String(lenValue); });
    }

    /* ---------------- Live total ---------------- */
    var priceObs = atbPrice ? new MutationObserver(function () { applyTotal(); }) : null;
    function observePrice() { if (priceObs) priceObs.observe(atbPrice, { childList: true, characterData: true, subtree: true }); }
    function applyTotal() {
      if (!atbPrice) return;
      var total = chainCents() + closureCents() + Math.round(lengthSurchargeEur() * 100);
      var html = ' · ' + formatMoney(total, money);
      if (priceObs) priceObs.disconnect();
      atbPrice.innerHTML = html;
      if (priceObs) { priceObs.takeRecords(); observePrice(); }
    }
    observePrice();
    if (idInput) {
      new MutationObserver(function () { syncLengthForBase(); applyTotal(); })
        .observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var id = sw.getAttribute('data-variant-id');
        var match = closures.filter(function (c) { return String(c.variantId) === String(id); })[0];
        if (match) { selected = match; markActive(); applyTotal(); }
      });
    });

    markActive();
    syncLengthForBase();
    applyTotal();

    /* ---------------- Bundled add to cart ---------------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var chainId = idInput && idInput.value;
        if (!chainId) return;
        var qtyEl = form.querySelector('[data-qty-input], [name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var build = 'pp_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

        var chainProps = { _build: build, _piece_title: data.chainTitle, _simple_bundle: '1' };
        if (data.parentVariantId) chainProps._bundle_parent = 'gid://shopify/ProductVariant/' + data.parentVariantId;
        // Image override MUST be an absolute URL with no transform param — linesMerge rejects the
        // whole operation otherwise. Liquid's image_url returns a protocol-relative "//cdn…?…&width="
        // URL, so make it absolute and strip the transform to match the (working) configurator format.
        var img = data.chainImage;
        if (img) {
          if (img.indexOf('//') === 0) img = 'https:' + img;
          img = img.replace(/[?&]width=\d+/, '');
          chainProps._snapshot_url = img;
        }
        if (selected) chainProps.Closure = closureLabel();
        if (lenCfg && rule() && lenValue != null) chainProps._selected_length = String(lenValue);

        var items = [{ id: Number(chainId), quantity: qty, properties: chainProps }];
        if (selected) items.push({ id: Number(selected.variantId), quantity: qty, properties: { _build: build } });

        // Length surcharge as the €/cm helper line (quantity = surcharge ÷ helper unit price).
        var sx = lengthSurchargeEur();
        var unit = lenCfg && lenCfg.surchargeUnitPrice;
        if (sx > 0 && unit > 0 && lenCfg.surchargeVariantId) {
          items.push({ id: Number(lenCfg.surchargeVariantId), quantity: Math.round(sx / unit) * qty, properties: { _build: build } });
        }

        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        var api = window.PaoPaoCart;
        var p = (api && api.addItems) ? api.addItems(items) : Promise.reject();
        p.then(function () {}).catch(function () {}).then(function () { if (btn) btn.disabled = false; });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-closure-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
